/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
import Vue from 'vue';
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
export default {
  name: 'apptReg',
  components: {},
  data: function data() {
    return {};
  },
  created: function created() {},
  mounted: function mounted() {},
  computed: {},
  watch: {},
  methods: {}
};